<template>
  <div class="member-course">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="课程名称">
        <Input
          v-model="searchCondition.title"
          placeholder="请输入课程名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">新增会员课程</Button>
      <span style="color:red;">*会员课程即为会员可免费观看的课程</span>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/vipCourse"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="vip_course_id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onDelete(row)">删除</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal v-model="showModal" title="选择课程" @on-ok="onConfirmSelectCourse" width="800">
      <CourseSelect ref="course" :vip_type="1" :status="1"></CourseSelect>
    </Modal>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";
import CourseSelect from "@/components/GridSelect/CourseSelect";

export default {
  name: "member-course",
  components: {
    CourseSelect
  },
  data() {
    return {
      searchCondition: {
        title: ""
      },
      tableColumns: [
        { title: "课程名称", key: "title", minWidth: 300 },
        { title: "课程类型", key: "typeName", align: "center", minWidth: 140 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 140,
          fixed: "right"
        }
      ],
      showModal: false
    };
  },
  created() {},
  methods: {
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.title = "";
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.showModal = true;
      this.$refs.course.refresh();
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "是否要删除当前会员课程？",
        onOk: () => {
          this.$http.delete("/api/vipCourse/" + row.vip_course_id).then(() => {
            this.$Message.success("删除成功");
            this.$refs.grid.refresh();
          });
        }
      });
    },
    onrowsFormatter(rows) {
      for (let i = rows.length - 1; i >= 0; i--) {
        if (rows[i].course_type == null) {
          rows.splice(i, 1);
        } else {
          rows[i].typeName = CouseType.getValue(rows[i].course_type);
        }
      }
    },
    onConfirmSelectCourse() {
      const list = this.$refs.course.getSelectList();
      if (!list.length) return;
      const ids = [];
      list.forEach(i => {
        ids.push(i.id);
      });
      this.$http
        .post("/api/vipCourse", {
          course_ids: ids.join()
        })
        .then(() => {
          this.$Message.success("添加成功");
          this.$refs.grid.refresh();
        });
      this.$refs.course.recoverSelectedItems([]);
    }
  }
};
</script>